// stores/popup-store.ts
import { Instance, SnapshotOut, types, flow } from "mobx-state-tree"

export const PopupItemModel = types
  .model("PopupItem", {
    id: types.identifierNumber,
    options: types.frozen<any>(),
  })
  .volatile(() => ({
    resolver: null as null | ((v?: any) => void),
  }))
  .actions((self) => ({
    setResolver(fn: ((v?: any) => void) | null) {
      self.resolver = fn
    },
  }))

export const PopupStoreModel = types
  .model("PopupStore", {
    stack: types.array(PopupItemModel),
    closingIds: types.array(types.number),
    nextId: 0,
  })
  .actions((self) => ({
    /** 打开弹窗 */
    open(options: any) {
      const id = self.nextId++
      let resolver: ((v?: any) => void) | null = null

      const promise = new Promise<any>((resolve) => {
        resolver = resolve
      })

      const item = PopupItemModel.create({ id, options })
      item.setResolver(resolver)

      self.stack.push(item)
      return promise
    },

    /** 关闭顶部弹窗 */
    close(result?: any) {
      const top = self.stack[self.stack.length - 1]
      if (!top) return

      if (!self.closingIds.includes(top.id)) {
        self.closingIds.push(top.id)
      }
    },

    /** Reanimated 动画完毕调用 */
    onRequestClose: flow(function* onRequestClose(id: number, result?: any) {
      const idx = self.stack.findIndex((p) => p.id === id)
      if (idx === -1) return

      const item = self.stack[idx]

      // 外部代码（Promise resolve）
      try {
        item.resolver?.(result)
      } catch {}

      // flow 会保护下面所有 MST 修改
      item.setResolver(null)

      self.stack.splice(idx, 1)
      self.closingIds.replace(self.closingIds.filter((x) => x !== id))
    }),
  }))

export type PopupStore = Instance<typeof PopupStoreModel>
export type PopupStoreSnapshot = SnapshotOut<typeof PopupStoreModel>
export const createPopupStoreDefaultModel = () => types.optional(PopupStoreModel, {})
